export default __webpack_public_path__ + "static/media/tw.5d5aa602.svg";